import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96adbd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "subtitles"
}

import {ref} from 'vue'
  import store from '@/store'
  import {t} from '@/lib/i18n'
  import {subtitle} from '@/lib/subtitles'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSubtitles',
  setup(__props, { expose }) {

  expose({
    update: update
  })

  const currentSubtitleId = ref(null)
  const currentSubtitle = ref('')

  function update(key: string, time: number) {
    // Get first subtitle matching current time
    const newSubtitleId = subtitle(key, time)

    // If subtitle is different from current subtitle potentially set it
    if (newSubtitleId !== currentSubtitleId.value) {
      currentSubtitleId.value = newSubtitleId
      // If subtitle exists set, else unset
      if (newSubtitleId !== null) {
        const newSubtitle = t(store, key + '.' + currentSubtitleId.value)
        setText(newSubtitle)
      } else {
        unsetText()
      }
    }
  }

  function setText(text: string) {
    currentSubtitle.value = text
  }

  function unsetText() {
    currentSubtitle.value = ''
  }

return (_ctx: any,_cache: any) => {
  return (currentSubtitle.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(currentSubtitle.value), 1))
    : _createCommentVNode("", true)
}
}

})